import { render, staticRenderFns } from "./AffiliatePayout.vue?vue&type=template&id=ca79d37e&"
import script from "./AffiliatePayout.vue?vue&type=script&lang=js&"
export * from "./AffiliatePayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports